interface ErrorLandingProps {
  heading: string;
  subHeading: string;
  description?: string;
  footer?: string;
}

export function ErrorLanding({
  heading,
  subHeading,
  description = '',
  footer = '',
}: ErrorLandingProps) {
  return (
    <div className="min-h-svh flex items-center justify-center p-8 animate-in fade-in duration-300">
      <div className="bg-white rounded-2xl shadow-md p-8 max-w-md text-center space-y-4">
        <div>
          <h3 className="text-2xl font-bold text-foreground">{heading}</h3>
          <p className="text-lg font-semibold text-muted-foreground mt-2">
            {subHeading}
          </p>
        </div>
        {(description || footer) && (
          <>
            <div className="border-t border-border pt-4" />
            {description && (
              <p className="text-sm font-semibold text-foreground">{description}</p>
            )}
            {footer && (
              <p className="text-sm text-muted-foreground">{footer}</p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
